<template>
  <div class="bargain-entry" v-if="bargainedPrice">
    <div class="bargain-info">
      <div class="bargain-price-row">
        <span class="bargain-price-label">砍后价</span>
        <span class="bargain-currency">¥</span>
        <span class="bargain-price-value">{{ bargainedPrice }}</span>
      </div>
      <div class="bargain-saving-row">
        <span class="bargain-saving-tip">好友助砍，最高省</span>
        <div class="bargain-saving-tag">{{ maxSaveAmount }}元</div>
      </div>
    </div>
    <div
      class="bargain-action-btn"
      :class="{ 'bargain-action-btn--disabled': isBargainDisabled }"
      @click="handleBargainClick"
    >立即砍价</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
import { setBaseUrl, setTokenFromCookie } from '@/utils/tools';
export default {
  props: {
    buyBtnData: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    ...mapState(['allAcvitity', 'productSku', 'userInfo']),
    currentSkuPrice() {
      const { productSkuId } = this.productSku;
      const skuPriceList = this.allAcvitity?.bargainActivityDetail?.skuPriceList || [];
      if (!productSkuId) return null;
      return skuPriceList.find(
        (item) => Number(item.productSkuId) === Number(productSkuId),
      ) || null;
    },
    bargainedPrice() {
      const currentSku = this.currentSkuPrice;
      if (!currentSku) return '';
      return currentSku.skuFloorPrice ?? '';
    },
    maxSaveAmount() {
      const currentSku = this.currentSkuPrice;
      if (!currentSku) return '';
      const original = Number(currentSku.originalPrice) || 0;
      const floor = Number(currentSku.skuFloorPrice) || 0;
      const amount = original - floor;
      return amount > 0 ? amount.toFixed(0) : '0.0';
    },
    isBargainDisabled() {
      const state = Number(this.buyBtnData?.state);
      return !Number.isNaN(state) && state <= 5;
    },
  },
  methods: {
    handleBargainClick() {
      if (this.isBargainDisabled) return;

      const activityId = this.allAcvitity?.bargainActivityDetail?.id;
      const skuId = this.productSku?.productSkuId;
      if (!activityId || !skuId) return;

      if (this.userInfo?.id) {
        this.goBargainDetail(activityId, skuId);
        return;
      }

      if (this.$root.$data.isApp) {
        this.$sendToApp('login', {}, true)
        return;
      }

      if (this.$root.miniprogram) {
        const bargainUrl = `${window.location.origin}/ark/personalCenter/bargainDetail?activityId=${activityId}&skuId=${skuId}`;
        const redirctUrl = encodeURIComponent(
          `/subPackages/customShareWebview/webView?url=${encodeURIComponent(bargainUrl)}`,
        );
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({ url: path });
        return;
      }

      this.$router.push({
        path: '/registrationLogin',
        query: {
          redirect: '/personalCenter/bargainDetail',
          activityId,
          skuId,
        },
      });
    },
    goBargainDetail(activityId, skuId) {
      const pagePath = `/ark/personalCenter/bargainDetail?activityId=${activityId}&skuId=${skuId}`;
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          { url: `${setBaseUrl('')}${pagePath}` },
          false,
        );
        return;
      }
      this.$router.push({
        path: '/personalCenter/bargainDetail',
        query: { activityId, skuId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.bargain-entry {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 678px;
  min-height: 111px;
  margin: 0 auto 40px;
  margin-top: 12px;
  padding: 0 20px 0 150px;
  background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/bargain/bargain-entry.png')
    100% no-repeat;
  background-size: 100% 100%;
}

.bargain-info {
  flex: 1;
  min-width: 0;
}

.bargain-price-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-right: 9px;
}

.bargain-price-label,
.bargain-currency {
  color: #ff3938;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
}

.bargain-price-label {
  margin-top: 4px;
  color: #ff3938;
  font-weight: 600;
  font-size: 25px;
}

.bargain-currency {
  margin: 4px 0 0 4px;
  color: #ff3938;
  font-weight: 600;
  font-size: 25px;
}

.bargain-price-value {
  color: #ff3938;
  font-weight: 600;
  font-size: 33px;
  line-height: 25px;
  white-space: nowrap;
}

.bargain-saving-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  // justify-content: space-between;
  // width: 142px;
  margin-top: 5px;
}

.bargain-saving-tip {
  color: #ff3938;
  font-weight: 400;
  font-size: 22px;
  white-space: nowrap;
}

.bargain-saving-tag {
  margin-left: 10px;
  // flex-shrink: 0;
  padding: 4px 7px;
  color: #fff;
  font-weight: 500;
  font-size: 22px;
  background-color: #ff3938;
  border-radius: 3px 3px 3px 3px;
}

.bargain-action-btn {
  position: relative;
  flex-shrink: 0;
  width: 192px;
  height: 67px;
  margin: 0 3px;
  color: #fff;
  font-weight: 600;
  font-size: 25px;
  line-height: 67px;
  text-align: center;
  background: #ff2919;
  background-color: #ff2919;
  border-radius: 40px;

  &--disabled {
    color: #fff;
    background: #ccc;
    background-color: #ccc;
    pointer-events: none;
  }
}

.bargain-action-text {
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
}

.bargain-action-deco {
  position: absolute;
  top: -38px;
  left: 75px;
  width: 64px;
  height: 60px;
}
</style>
